import {
    CREATE_ACCOUNT_YIELD,
    CREATE_ACCOUNT_YIELD_FAILURE,
    CREATE_ACCOUNT_YIELD_SUCCESS,
} from 'store/actions/types';
import accountYieldsHelper from 'helpers/accountYields';

export const createAccountYield = (payload) => {
    const values = accountYieldsHelper.formatToPercentage(payload.values, 'yield');

    const normalised = Object.assign({}, payload, values);

    return {
        type: CREATE_ACCOUNT_YIELD,
        payload: normalised,
    };
};

export const createAccountYieldFailure = (error) => {
    return {
        type: CREATE_ACCOUNT_YIELD_FAILURE,
        error: error,
    };
};

export const createAccountYieldSuccess = (response) => {
    return {
        type: CREATE_ACCOUNT_YIELD_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/account-yields/createAccountYields.js